module.exports = __webpack_public_path__ + "img/zhineng.602c99e9.jpg";